<template>
	<div class="cart__product cartitem">
		<div class="cartitem__img" v-if="item.gallery">
			<img :src="item.gallery[0].path" alt="">
		</div>

		<div class="cartitem__title">{{ item.title }} <small>{{item.intro }}</small></div>

		<div class="props__item">
			<div class="props__title">Объем / вес:</div>
			<div class="props__title">{{ item.currentProp.vol }} {{ item.currentProp.unit == 'литр' ? 'мл' : item.currentProp.unit }}</div>
			<!--<select class="uk-select">
				<option>1 л</option>
				<option>0.5 л</option>
			</select>-->
		</div>

		<div class="props__item">
			<div class="props__title">Количество:</div>
			<div class="props__count">
				<button uk-icon="minus" @click="minus"></button>
				<strong>{{ count }}</strong>
				<button uk-icon="plus" @click="plus"></button>
			</div>
		</div>

		<div class="props__item">
			<div class="props__title">Цена товара:</div>
			<div class="props__price props__price--small">{{ item.currentProp.price }} ₽</div>
		</div>

		<div class="props__item">
			<div class="props__title">Сумма:</div>
			<div class="props__sum props__sum--small">{{ item.currentProp.price * count | cifer }} ₽</div>
		</div>

		<div class="cartitem__close" @click="removeItem()">
			<span uk-icon="close"></span>
		</div>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  export default {
    name: "cart-item",
	  data(){
      return {
        count: ''
      }
	  },
	  props:{
      item: ''
	  },
	  methods: {
      plus() {
        this.count++;
        this.updateCart();
      },
      minus() {
        if (this.count > 1) {
          this.count--;
          this.updateCart();
        }
      },
		  updateCart(){
        let item = this.item;
        item.count = this.count;
        let app = this;
        $.request('onUpdateCount', {
          data: { item: item},
          success: function (data) {
            console.log(data);
            app.$emit('updateCount', data.item);
            bus.$emit('cart-reload', data.cart);
          },
          error: function (err) {
            console.log(err);
          }
        })
		  },
		  removeItem(){
        let app = this;
        $.request('onRemoveItem', {
          data: { item: this.item},
          success: function (data) {
            //console.log(data);
            app.$emit('removeFromCart', data.id);
            bus.$emit('cart-reload', data.cart);
          },
          error: function (err) {
            console.log(err);
          }
        })
		  }
	  },
	  mounted(){
      this.count = this.item.count;
	  }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/cart-item.vue